class DeleteOrganization {
	constructor(
		public readonly accountId: number,
		public readonly organizationId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteOrganization;
